export const SurchargesKpisActionTypes = {
    API_RESPONSE_SUCCESS: '@@surcharges-kpis/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@surcharges-kpis/API_RESPONSE_ERROR',
    GET_TOTAL_SURCHARGES_COST: '@@surcharges-kpis/GET_TOTAL_SURCHARGES_COST',
    GET_TOTAL_NON_SHIPMENT_SURCHARGES_COST: '@@surcharges-kpis/GET_TOTAL_NON_SHIPMENT_SURCHARGES_COST',
    GET_TOTAL_NO_SURCHARGES: '@@surcharges-kpis/GET_TOTAL_NO_SURCHARGES',
    GET_TOTAL_NO_NON_SHIPMENT_SURCHARGES: '@@surcharges-kpis/GET_TOTAL_NO_NON_SHIPMENT_SURCHARGES',
    GET_SURCHARGE_SUMMARY: '@@surcharges-kpis/GET_SURCHARGE_SUMMARY',
    GET_NON_SHIPMENT_SURCHARGE_SUMMARY: '@@surcharges-kpis/GET_NON_SHIPMENT_SURCHARGE_SUMMARY',
    GET_SURCHARGES_BY_TIMEFRAME: '@@surcharges-kpis/GET_SURCHARGES_BY_TIMEFRAME',
};
